import CustomerInfoSection from './CustomerInfoSection';
import InvoiceInfoSection from './InvoiceInfoSection';
import OrderMethodDetailsSection from './OrderMethodDetailsSection';
import PaymentInfoSection from './PaymentInfoSection';
import RememberMeSection from './RememberMeSection';

export default {
  CustomerInfoSection,
  InvoiceInfoSection,
  OrderMethodDetailsSection,
  PaymentInfoSection,
  RememberMeSection,
};
